import { Stack } from "@mui/material";
import { useEffect } from "react";
import LogInButton from "../LogIn/LogInButton";
import Image from "../../uiComponents/Image/Image";

const PrevUserExistant = () => {
  useEffect(() => {
    localStorage.removeItem("chosen_login");
  }, []);

  return (
    <Stack>
      <h1 className="margin-v-l">Logueese con GOOGLE</h1>
      <p className="margin-v">
        Useted se logueo con Usuario y conrtaseña pero ya tiene un usuario con
        google. Por favor logueese con google haciendo click en el boton de
        abajo.
      </p>

      <LogInButton
        className="nav-element-login b-primary mobile-disapear margin-v"
        label="Loguearse con Google"
        style={{ width: "230px", margin: "12px auto" }}
      />
      <Image
        name="log-example.png"
        style={{ width: "400px", maxWidth: "90vw", margin: "0 auto" }}
      />
    </Stack>
  );
};

export default PrevUserExistant;
